module.exports = __webpack_public_path__ + "img/bold-checkbox-checked.f4d3e5b4.svg";